import { NotificationContext } from '@app/providers/notification/notification';
import { useContext } from 'react';

export type NotifyType = 'success' | 'info' | 'warning' | 'error';

export interface NotifyParams {
  type?: NotifyType;
  message: React.ReactNode;
  description?: React.ReactNode;
  duration?: number;
  placement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
  pauseOnHover?: boolean;
  showProgress?: boolean;
}

export const useNotify = () => {
  const api = useContext(NotificationContext);
  if (!api) throw new Error('useNotify must be used within a NotificationProvider');

  return (params: NotifyParams) => {
    const { type = 'error', ...rest } = params;
    api[type]({
      duration: 3,
      placement: 'bottomRight',
      pauseOnHover: true,
      showProgress: true,
      ...rest,
    });
  };
};
